import { render, staticRenderFns } from "./VuePageLayout.vue?vue&type=template&id=70d9e506&"
import script from "./VuePageLayout.vue?vue&type=script&lang=js&"
export * from "./VuePageLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports